// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"7f31a8cd","326":"026145df","344":"12bc5993","630":"d8c9c854","673":"ee19793a"}[chunkId] + ".chunk.js";
};